'use strict';

import template from '../templates/LocationModal.ejs';
import modal from 'helpers/modal';
import tooltip from 'helpers/tooltip';
import Address from 'newModels/address.js';
import Alerts from 'lib/alerts';

module.exports = Backbone.View.extend({

    className: 'modal inmodal',

    events: {
        'click .js-cancel':               'cancel',
        'click .js-remove':               'remove',
        'click .js-save':                 'save',
        'change input:not(.js-address)':  'updateModel',
        'change select:not(.js-address)': 'updateModel',
        'change input.js-address':        'updateModelAddress',
        'change select.js-address':       'updateModelAddress'
    },

    initialize: function() {
        if (this.model) {
            this.bindHandlers();
            this.render();
        }

        return this;
    },

    bindHandlers: function() {
        this.model.on('invalid', this.invalid, this);
        this.model.on('change', this.valid, this);
    },

    setModel: function(model) {
        this.model = model;
        this.bindHandlers();
    },

    render: function(addMode) {
        this.$el.html(template({
            model: this.model,
            addMode: !!addMode,
            states: Address.getStatesList()
        }));
        tooltip.init(this);
        return this;
    },

    updateModel: function(ev) {
        var $el = $(ev.currentTarget);
        var attr = $el.attr('name');

        this.model.set(
            {[attr]: $el.val()},
            {validateAttrs: {include: [attr]}}
        );
    },

    updateModelAddress: function(ev) {
        var $el = $(ev.currentTarget);
        var attr = $el.attr('name');

        if (!this.model.getAddress()) {
            return;
        }

        this.model.getAddress().set(
            {[attr]: $el.val()},
            {validateAttrs: {include: [attr]}}
        );
    },

    toggleError: function(attribute, message) {
        this.$('[name=' + attribute + ']')
            .closest('.form-group')
            .toggleClass('has-error', !_.isUndefined(message));
        this.$('.error-' + attribute).text(message);

        const hasError = this.$('[name=' + attribute + ']')
            .closest('.form-group')
            .hasClass('has-error');
        if (!hasError) {
            this.$('span.error-' + attribute).hide();
        } else {

            this.$('span.error-' + attribute).show();
        }
    },

    invalid: function(model, error) {
        Object.keys(error || {}).forEach(attribute => {
            this.toggleError(attribute, error[attribute][0]);
        });
    },

    valid: function(model) {
        const address = model.getAddress();

        if (address) {
            Object.keys(address.changed || {}).forEach(attr => {
                this.toggleError(attr);
            });
        }

        Object.keys(model.changed || {}).forEach(attr => {
            this.toggleError(attr);
        });
    },

    save: function() {
        //Whenever you try to put a invalid value into model it rises a error and
        //DO NOT PUT such value into the model, so the UI and MODEL get OUT OF SYNC
        //So we must validate UI for valid values too, before save it.
        const nameValue = this.$('[name="name"]').val();
        const hasNameErrors = this.model.validate({name: nameValue}).name;

        if (this.model.isValid() && !hasNameErrors) {
            this.trigger('save', this.model);
            this.hide();
            if (this.model.locations) {
                this.model.locations.add(this.model);
            }
        } else {
            const state = this.model.getAddress().get('state');
            if (!state) {
                this.toggleError('state', 'State is required');
            }

            if (hasNameErrors) {
                this.toggleError('name', 'Name is required');
            }

            // TODO this block of code seems to serve no purpose. Looks safe to
            // delete but not sure
            if (this.model.validationError) {
                const errors = this.model.validationError.name;
                if (errors) {
                    const nameError = errors
                        .find(error => error.includes('Name'));
                    this.toggleError('name', nameError);
                }
            }
        }
    },

    show: function() {
        this.$el.modal('show');
    },

    hide: function() {
        this.$el.modal('hide');
    },

    cancel: function() {
        this.hide();
    },

    remove: function() {
        const employees = this.model.getEmployees();
        if (employees.length > 0) {
            const employeeNames = employees
                .map(employee => employee.get('fullName'))
                .join(', ');

            Alerts.show('confirm', {
                title: 'Important note!',
                text: `Note: employee(s) (${employeeNames}) are ` +
                    `assigned to this location. If you choose to ` +
                    `remove Location, employee(s) will be ` +
                    `assigned to HQ location.`,
                confirmButtonText: 'Delete',
                cancelButtonText:  'Cancel',
                callback: confirm => {
                    if (confirm) {
                        this.trigger('remove', this.model);
                        this.hide();
                    }
                }
            });
        } else {
            this.trigger('remove', this.model);
            this.hide();
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/LocationModal.js